<template>
  <div class="page">
    <div class="el-flex">
      <div class="title">售后服务</div>
      <div class="icon-flex">
        <div class="icon-flex-item" @click="cjwt">
          <div class="item-img"><img src="@/assets/newUser/29.png" alt=""></div>
          <div class="item-name">常见问题</div>
        </div>
        <div class="icon-flex-item" @click="toBuyPrice()">
          <div class="item-img"><img src="@/assets/newUser/33.png" alt=""></div>
          <div class="item-name">参与优惠</div>
        </div>
        <div class="icon-flex-item" @click="showPasswordPanel = true">
          <div class="item-img"><img src="@/assets/home/22.png" alt=""></div>
          <div class="item-name">余额密码</div>
        </div>
        <div class="icon-flex-item" @click="kfClick">
          <div class="item-img"><img src="@/assets/newUser/32.png" alt=""></div>
          <div class="item-name">联系客服</div>
        </div>
        <div class="icon-flex-item" @click="outLogin">
          <div class="item-img"><img src="@/assets/newUser/31_1.png" alt=""></div>
          <div class="item-name">退出登录</div>
        </div>
      </div>
    </div>
    <div class="el-flex">
      <div class="title">查询办理</div>
      <div class="icon-flex">

        <div class="icon-flex-item" @click="autoPkg()">
          <div class="item-img"><img src="@/assets/newUser/33.png" alt=""></div>
          <div class="item-name">自动续费</div>
        </div>


        <div class="icon-flex-item" @click="tuiGuang">
          <div class="item-img"><img src="@/assets/newUser/34.png" alt=""></div>
          <div class="item-name">推广记录</div>
        </div>


        <div class="icon-flex-item" @click="toApplyTui">
          <div class="item-img"><img src="@/assets/newUser/33.png" alt=""></div>
          <div class="item-name">我的余额</div>
        </div>


        <div class="icon-flex-item" @click="gotoView">
          <div class="item-img"><img src="@/assets/newUser/34_1.png" alt=""></div>
          <div class="item-name">智能检测</div>
        </div>

        <div class="icon-flex-item" @click="toLog">
          <div class="item-img"><img src="@/assets/newUser/37.png" alt=""></div>
          <div class="item-name">充值记录</div>
        </div>


        <!-- <div>
              <a href="#/user/balanceRechargeRecord">
              <div class="item-img"><img src="@/assets/newUser/30.png" alt=""></div>
                <div class="shadow"></div>
                <span></span>
              </a>
            </div> -->
        <div class="icon-flex-item" @click="detailsTo">
          <div class="item-img"><img src="@/assets/newUser/35.png" alt=""></div>
          <div class="item-name">活动余额</div>
        </div>
        <div class="icon-flex-item" @click="realNameRegister">
          <div class="item-img"><img src="@/assets/home/20.png" alt=""></div>
          <div class="item-name">实名认证</div>
        </div>
        <div class="icon-flex-item" @click="toApplyShop">
          <div class="item-img"><img src="@/assets/newUser/30.png" alt=""></div>
          <div class="item-name">流量兑换券</div>
        </div>

        <!-- <div class="icon-flex-item" @click="toApplyTui">
                    <div class="item-img"><img src="@/assets/newUser/36.png" alt=""></div>
                    <div class="item-name">我的余额</div>
                </div> -->

      </div>
    </div>








    <!-- 修改密码框   -->
    <div class="van-overlay" style="z-index: 1999" v-show="showPasswordPanel"></div>
    <div class="van-popup van-popup--round van-popup--center changePasswordPanel" style="z-index: 2000; min-width: 80%"
      v-show="showPasswordPanel" :style="{ top: passwordPanelTop + '%' }">
      <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />

      <!-- 原密码输入框 -->
      <p>原密码：</p>
      <van-password-input :value="oldPassword" :focused="oldPasswordKeyboard" @focus="oldPasswordOnfocus()" />
      <!-- 新密码输入框 -->
      <p>新密码：</p>
      <van-password-input :value="newPassword" :focused="newPasswordKeyboard" @focus="newPasswordOnfocus()" />
      <!-- 原密码输入框 -->
      <p>再次确认：</p>
      <van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard" @focus="confirmPasswordOnfocus()" />
      <div class="confirmChangePassword">
        <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToChangePassword()">确
          定</van-button>
      </div>
    </div>

    <!-- 数字键盘 -->
    <van-number-keyboard :z-index="2015" :show="oldPasswordKeyboard" @input="oldPasswordOnInput"
      @delete="oldPasswordOnDelete" @blur="oldPasswordKeyboard = false" />

    <van-number-keyboard :z-index="2015" :show="newPasswordKeyboard" @input="newPasswordOnInput"
      @delete="newPasswordOnDelete" @blur="newPasswordKeyboard = false" />

    <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
export default {
  data() {
    return {

      //修改密码
      showPasswordPanel: false,

      oldPasswordKeyboard: false,
      newPasswordKeyboard: false,
      confirmPasswordKeyboard: false,

      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      passwordPanelTop: 50,
      //修改密码 end
      iccid: localStorage.getItem("iccid"),
    }
  },
  created() {
    this.getAccount()
  },
  methods: {
    autoPkg() {
      this.$router.push({
        path: '/user/renew'
      })
    },

    tuiGuang() {
      this.$router.replace('/user/feedback/list?disposeState=0')
    },
    outLogin() {
      localStorage.removeItem("userPhone");
      localStorage.removeItem("newUserPhone");
      localStorage.removeItem("newLoginText");
      localStorage.removeItem("recordLoginText");
      localStorage.removeItem("isShieldAgent");
      localStorage.removeItem("virtualNo");
      localStorage.removeItem("iccid");

      window.location.href = 'http://wx.519liuliang.com/#/newUser/bindNew/bindPhone';
    },
    toLog() {
      this.$router.replace('/user/balanceRechargeRecord')
    },
    toBuyPrice() {
      var record = {
        basePkgGroup: localStorage.getItem('basePkgGroup')
      }
      if (
        record.basePkgGroup === '1549295580465852416' ||
        record.basePkgGroup === '1568163178611732480'
      ) {
        // 悟空卡
        this.$router.replace('/newUser/simOpenWu')
      } else if (
        record.basePkgGroup === '1587749406130565120'
      ) {
        // 悟空卡Puls  105G
        this.$router.replace('/newUser/simOpenWup')
      } else if (
        record.basePkgGroup === "1710104773937590272"
      ) {
        //楷然直播
        this.$router.replace("/newUser/simOpen999");
      } else if (record.basePkgGroup === '1549295498467209216') {
        // 乐享卡
        this.$router.replace('/newUser/simOpenLe')
      } else if (
        record.basePkgGroup === '1562613197939142656' ||
        record.basePkgGroup === '1565598068475162624'
      ) {
        // 乐信卡 80元得240
        this.$router.replace('/user/simOpenLex')
      } else if (record.saleType == 20) {
        this.$router.replace("/newUser/simAllOpenThree");
      } else if (
        record.basePkgGroup === '1574325852529750016' ||
        record.basePkgGroup === '1574325802546229248'
      ) {
        // 悟净卡 开户预存 送赠送金
        this.$router.replace('/user/cardOpens')
      } else if (
        record.basePkgGroup === '1579392078893281280' ||
        record.basePkgGroup === '1579369236420096000' ||
        record.basePkgGroup === '1579369201724813312'
      ) {
        // 冰星系列 开户预存+赠送金
        this.$router.replace('/user/rechargePrice')
        // 畅享卡系列 30*3+20*9优惠券  9.9元套餐
      } else if (record.basePkgGroup === '1588080292403343360') {
        this.$router.replace('/newUser/simOpenCxk')
      }
      // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
      else if (record.basePkgGroup === '1595609837910093824') {
        this.$router.replace('/user/simOpenXy')
      }
      // 畅享卡系列 30*2+20*10优惠券  9.9元套餐
      else if (record.basePkgGroup === '1595609014362697728') {
        this.$router.replace('/newUser/simOpenYx')
      } else if (record.basePkgGroup === '1597081108845948928') {
        this.$router.replace('/newUser/simOpenXy8')
      } else if (record.basePkgGroup === '1620242289261539328') {
        this.$router.replace('/newUser/simOpenTn')
      } else if (record.basePkgGroup === '1630400735126482944') {
        this.$router.replace('/newUser/simOpenTnPNew')
      } else if (record.basePkgGroup === '1639175906637377536') {
        this.$router.replace('/newUser/simOpenXc')
      } else if (record.basePkgGroup === '1643557236171075584') {
        this.$router.replace('/newUser/simOpenXcp')
      } else if (record.basePkgGroup === '1647873729625059328') {
        this.$router.replace('/newUser/simOpenTnVip')
      } else if (record.basePkgGroup === '1643829249842343936') {
        this.$router.replace('/newUser/simOpenTnBz')
      } else if (record.basePkgGroup === '1656908136637788160') {
        this.$router.replace('/newUser/simOpenTnPUp')
      } else if (record.basePkgGroup === '1671694964578316288') {
        this.$router.replace('/newUser/simOpenZb')
      } else if (record.basePkgGroup === '1695020545449390080') {
        this.$router.replace('/newUser/simOpen100')
      } else if (record.basePkgGroup === '1695000953494695936') {
        this.$router.replace('/newUser/simOpen105')
      } else if (record.basePkgGroup === '1695000884909436928') {
        this.$router.replace('/newUser/simOpen108')
      } else if (record.basePkgGroup === '1594586861022474240') {
        this.$router.replace('/newUser/simOpenSj')
      } else if (record.basePkgGroup === "1712013754339684352" || record.basePkgGroup === "1714210288590385152"
      || record.basePkgGroup === "1807621869617016833"   || record.basePkgGroup === "1854435462677000192" 
      || record.basePkgGroup === "1715188857181302784"
        || record.saleType >= 12) {
        //统一页面
        this.$router.replace("/newUser/simAllOpen");
      } else {
        Dialog.alert({ message: "当前卡暂无优惠活动，如有疑问 请联系客服咨询。" });
      }
    },

    /***   修改密码     ***/
    oldPasswordOnfocus() {
      this.oldPasswordKeyboard = true;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    oldPasswordOnDelete() {
      this.oldPassword = this.oldPassword.slice(0, this.oldPassword.length - 1);
    },

    oldPasswordOnInput(key) {
      this.oldPassword = (this.oldPassword + key).slice(0, 6);
    },

    newPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    newPasswordOnDelete() {
      this.newPassword = this.newPassword.slice(0, this.newPassword.length - 1);
    },

    newPasswordOnInput(key) {
      this.newPassword = (this.newPassword + key).slice(0, 6);
    },

    confirmPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(
        0,
        this.confirmPassword.length - 1
      );
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },

    cancelChangePassword() {
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    sureToChangePassword() {
      if (
        this.oldPassword.length < 6 ||
        this.newPassword.length < 6 ||
        this.confirmPassword.length < 6
      ) {
        Dialog.alert({ message: "请输入六位密码" });
        return;
      }

      if (this.newPassword != this.confirmPassword) {
        Dialog.alert({ message: "两次输入的新密码不一致" });
        return;
      }

      let data = {
        iccid: this.$store.state.iccid,
        paypassOld: this.oldPassword,
        paypass: this.confirmPassword,
      };
      wxRequest("sysUser/account/user/resetPaypass", data, "post").then(
        (res) => {
          if (res.data.code == 200) {
            Toast.success(res.data.message);
            this.cancelChangePassword();
          } else {
            Dialog.alert({ message: res.data.message });
          }
        }
      );
    },
    /***   修改密码  end   ***/

    state() {
      this.$router.push({
        path: "/newUser/entrance",
      });
    },
    cjwt() {
      this.$router.push({
        path: "/newUser/problem",
      });
    },
    gotoView() {
      this.$router.replace("/newUser/diagnosis");
    },
    kfClick() {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL'
    },
    detailsTo() {
      this.$router.push({
        path: "/newUser/coupon",
        query: {
          iccid: this.iccid,
        },
      });
    },
    toApplyShop() {
      this.$router.push({
        name: "applyShop",
        query: { iccid: this.iccid },
      });
    },
    toApplyTui() {
      this.$router.push({
        path: "/new/yue",
        query: { iccid: this.iccid },
      });
    },
    realNameRegister() {
      wxRequest("sim/detail", { iccid: this.iccid }, "post").then((res) => {
        if (res.data.code === '200') {
          this.simInfo = res.data.data
          var simpkg = {
            iccid: this.simInfo.iccid,
          };
          let iccid = this.simInfo.iccid;
          wxRequest("bindPhone/sim/pkg", simpkg, "post").then((res) => {
            if (res.data.code != 200) {
              Dialog.confirm({
                title: "购买套餐提醒",
                message: "请点击 确定 购买套餐后，再进行实名激活操作！",
              }).then((action) => {
                if (action == "confirm") {
                  this.$router.replace("/user/recharge");
                }
              }).catch(() => { });
            } else {
              if (
                this.simInfo.supplierTypeCode == 1 ||
                this.simInfo.supplierTypeCode == 5
              ) {
                Dialog.confirm({
                  title: "实名提示",
                  message:
                    "请复制此ICCID：" +
                    this.simInfo.iccid +
                    "，点击确认 去完成实名",
                })
                  .then(() => {
                    window.location.href =
                      "http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504";
                  })
                  .catch(() => { });
              } else if (this.simInfo.supplierTypeCode == 3) {
                //移动
                wxRequest("/sim/get/cmcc/auth", { iccid: iccid }, "get").then((res) => {
                  if (res.data.code == 200) {
                    window.location.href = res.data.data;
                  } else {
                    Dialog.alert({
                      title: "提示",
                      message: res.data.message,
                    });
                  }
                });
              } else {
                Dialog.confirm({
                  title: "实名提示",
                  message:
                    "已自动复制实名卡号！卡号为：" +
                    iccid +
                    "，点击确定去完成实名后 方可正常激活使用.如已实名 请忽略",
                })
                  .then((action) => {
                    Toast.fail("卡号复制成功");
                    if (action == "confirm") {
                      // var clipboard = new Clipboard(".tag-read");
                      // clipboard.on("success", (e) => {
                      //   console.log("复制成功");
                      //   clipboard.destroy(); // 释放内存
                      // });
                      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                        //ios系统
                        window.getSelection().removeAllRanges(); //这段代码必须放在前面否则无效
                        let inputDom = document.createElement("input");
                        document.body.appendChild(inputDom);
                        // inputDom.setAttribute("value", iccid);
                        // let copyDom=document.getElementById("copyDom");//要复制文字的节点
                        // copyDom.appendChild(inputDom);// 把标签添加给body
                        // inputDom.style.opacity = 0;//设置input标签设置为透明(不可见)
                        inputDom.value = iccid; // 修改文本框的内容
                        inputDom.select();
                        let range = document.createRange();
                        // 选中需要复制的节点
                        range.selectNode(inputDom);
                        // 执行选中元素
                        window.getSelection().addRange(range);
                        inputDom.setSelectionRange(0, inputDom.value.length); //适配高版本ios
                        // 执行 copy 操作
                        document.execCommand("copy");
                        // 移除选中的元素
                        window.getSelection().removeAllRanges();
                        document.body.removeChild(inputDom);
                      } else {
                        const save = function (e) {
                          e.clipboardData.setData("text/plain", iccid);
                          e.preventDefault(); // 阻止默认行为
                        };
                        document.addEventListener("copy", save);
                        document.execCommand("copy");
                      }
                      window.location.href =
                        "https://env-9gk22lag4fab0241-1309553396.tcloudbaseapp.com/jump-mp.html";
                    }
                  })
                  .catch(() => { });
              }
            }
          });
        } else {
          Toast.fail(res.data.message);
        }
      })

    },
    realName() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        //ios系统
        window.getSelection().removeAllRanges() //这段代码必须放在前面否则无效
        let inputDom = document.createElement("input")
        inputDom.value = this.iccid; // 修改文本框的内容
        document.body.appendChild(inputDom)
        inputDom.select();
        let range = document.createRange()
        // 选中需要复制的节点
        range.selectNode(inputDom)
        // 执行选中元素
        window.getSelection().addRange(range)
        inputDom.setSelectionRange(0, inputDom.value.length); //适配高版本ios
        // 执行 copy 操作
        document.execCommand("copy")
        // 移除选中的元素
        window.getSelection().removeAllRanges()
        document.body.removeChild(inputDom)
      } else {
        const save = function (e) {
          e.clipboardData.setData("text/plain", this.iccid)
          e.preventDefault(); // 阻止默认行为
        };
        document.addEventListener("copy", save)
        document.execCommand("copy")
      }
      Toast.fail("卡号复制成功")
      window.location.href = "https://env-9gk22lag4fab0241-1309553396.tcloudbaseapp.com/jump-mp.html"
    },
    getAccount() {
      let param = {
        iccid: this.iccid,
        mobile: localStorage.getItem("mobile"),
      };
      //若为总部微信公众号
      if (localStorage.getItem("isHeadquarterAppid")) {
        wxRequest("/sysUser/account/querySysUserAccount", param, "post").then((res) => {
          if (res.data.code === '200') {
            this.userAccount = res.data.data;
            this.alreadyHasAccount = true;
          } else if (res.data.code === '400') {
            let self = this;
            if (self.$store.state.supplierCode == "1197749413972275200") {
              Dialog.confirm({
                title: "提示",
                message: "首次使用需进行充值，请点击【确认】前往充值",
              }).then(() => {
                self.$router.replace("/newUser/recharge");
              }).catch(() => { })
            }
          }
        })
      } else { //若为代理商公众号
        wxRequest("/sysUser/account/querySysUserAccount", param, "post").then((res) => {
          if (res.data.code === '200') {
            this.userAccount = res.data.data
            this.alreadyHasAccount = true
          }
        })
      }
    },
    toBalanceRecharge() {
      this.$router.push({
        path: "/user/balanceRechargeRecord",
        query: {
          iccid: this.$store.state.iccid,
        },
      });
    }
  }
}
</script>
<style lang="less">
.changePasswordPanel {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    align-items: center;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }
}
</style>

<style lang="less" scoped>
div {
  display: flex;
  flex-grow: 0;
  flex-basis: auto;
  align-items: stretch;
  flex-direction: column;
}

.page {
  height: 100%;
  background: #f7f8fa;

  .el-flex {
    background-color: #fff;
    align-self: center;
    margin-top: 20px;
    border-radius: 20px;
    padding: 12px 0;
    width: 90%;

    .title {
      font-size: 15px;
      font-weight: 700;
      color: #06121e;
      margin-left: 15px;
      margin-bottom: 7px;
    }

    .icon-flex {
      flex-wrap: wrap;
      flex-direction: row;

      .icon-flex-item {
        min-width: 83px;
        margin: 10px 0px 10px;
        align-items: center;
        flex-direction: column;

        .item-img {
          width: 48px;
          height: 48px;
        }

        .item-name {
          font-size: 12px;
          font-weight: 700;
          color: #3d444d;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>